export async function getTemperatureDataOfMonth(month) {
    const data = await $fetch(`/api/weather/temperature-by-month?month=${month}`)
    const values = {}

    Object.entries(data).forEach(([key, value]) => {
        values[`${key}_celsius`] = toCelsius(value)
        values[`${key}_fahrenheit`] = toFahrenheit(value)
    })

    return values
}

export function toCelsius(kelvin) {
    return `${Math.round(kelvin - 273.15)}°C`
}

export function toFahrenheit(kelvin) {
    return `${Math.round((kelvin - 273.15) * 9 / 5 + 32)}°F`
}
